import {notification} from 'antd';
import axios, {AxiosError, AxiosRequestConfig} from 'axios';
import getConfig from '../config';


const ins = axios.create({
  withCredentials: true,
});


function errorText(data: any): React.ReactChild | null {
  if (!data) {
    return null;
  }
  if (data instanceof String) {
    return `error: ${data as string}`;
  }
  if (data instanceof Object) {
    return <>error: <br /><pre>{JSON.stringify(data, null, 2)}</pre></>;
  }
  return 'error: ';
}


ins.interceptors.response.use(undefined, (err: AxiosError) => {
  notification.error({
    message: 'API Request Error',
    description: <>
      {err.config.method} {err.config.url}
      <br />
      {err.message}
      <br />
      {err.response?.status} {err.response?.statusText}
      <br />
      {errorText(err.response?.data)}
    </>,
  });
  return Promise.reject(err);
});


type RequestFn<Request, Response> = (data?: Request, config?: AxiosRequestConfig<Request>) => Promise<Response>

async function getURL(path: string): Promise<string> {
  return `${(await getConfig()).Backend.Host}${path}`;
}

export function makeGet<Request, Response>(path: string, makeConfig?: AxiosRequestConfig<Request> ): RequestFn<Request, Response> {
  return async (data?, config?): Promise<Response> => (await ins.get((await getURL(path)), {
    ...(makeConfig || {}),
    ...(config || {}),
    ...(data ? {params: data} : {}),
  })).data;
}

export function makePut<Request extends object, Response>(path: string, makeConfig?: AxiosRequestConfig<Request> ): RequestFn<Request, Response> {
  return async (data?, config?): Promise<Response> => (await ins.put(`${(await getConfig()).Backend.Host}${path}`, data, {
    ...(makeConfig || {}),
    ...(config || {}),
  })).data;
}

export function makePost<Request extends object, Response>(path: string, makeConfig?: AxiosRequestConfig<Request> ): RequestFn<Request, Response> {
  return async (data?, config?): Promise<Response> => (await ins.post(`${(await getConfig()).Backend.Host}${path}`, data, {
    ...(makeConfig || {}),
    ...(config || {}),
  })).data;
}
